<ng-container *ngIf="!loading; else dataLoading">
  <ng-container *ngIf="dataWithLocation; else noLocationData">
    <app-search-map [attr.data-search-enabled]="searchEnabled ? true : false" [searchEnabled]="searchEnabled"
      (addressFound)="onAddressFound($event)" (propertyFound)="onPropertyFound($event)">
    </app-search-map>

    <app-new-map [hasSatelliteView]="hasSatelliteView" [hasPlanView]="hasPlanView"
      [hasEventParcelles]="hasEventParcelles" [updateLocationEnabled]="updateLocationEnabled" propsType="summary"
      [props]="props" (locationUpdated)="locationUpdated.emit($event)" (mapServiceInstance)="onMapInstance($event)">
    </app-new-map>
  </ng-container>
</ng-container>

<ng-template #noLocationData>
  <span class="no-content">Aucune donnée de localisation disponible</span>
</ng-template>

<ng-template #dataLoading>
  <app-data-loading></app-data-loading>
</ng-template>